import { atom } from "recoil";

const basketState = atom({
    key: "basketState",
    default: {
        basket: { math: undefined, totsum: 0, totvolume: 0, totweight: 0 },
    },
});

export { basketState };